import { render } from "./themes-profile-others.vue?vue&type=template&id=5d5bf4df"
import script from "./themes-profile-others.vue?vue&type=script&lang=js"
export * from "./themes-profile-others.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__